import React from 'react';
import Icon from '../icon';
import { PhoneLink } from '../link';
import { EventAction } from '../../../../services/analytics';
import useTranslation from '../../../../hooks/useTranslation';
import { getPosition } from '../../../../services/analytics-helper';
import { useProduct } from '../../../../hooks';

const PhoneIcon: React.FC<{
	phoneNumber?: string;
	position?: string;
	className?: string;
}> = ({
	position,
	className = 'h-5 w-5 text-brand',
	phoneNumber: phoneNumberProp,
}) => {
	const { t } = useTranslation();
	const {
		params: { phoneNumber: phoneNumberParam },
	} = useProduct();

	const phoneNumber = phoneNumberProp ?? phoneNumberParam;
	const phonePosition = position ? `Phone${position}` : '';
	const phoneAction = getPosition(phonePosition) as EventAction;

	return (
		<PhoneLink phoneNumber={phoneNumber} action={phoneAction}>
			<div>
				<span className="sr-only">{t('pages.icons.phone')}</span>
				<Icon
					className={className}
					type="phone"
					title={t('pages.phone.icon')}
				/>
			</div>
		</PhoneLink>
	);
};

export default PhoneIcon;
